/**
 * LV status constants for change orders
 * These are the internal normalized status codes that come from the backend
 */

// Define the status codes that come from the backend
export const LV_STATUS = {
	DRAFT: "DRAFT",
	PENDING_INTERNAL: "PENDING_INTERNAL",
	PENDING_CLIENT: "PENDING_CLIENT",
	APPROVED: "APPROVED",
	REJECTED: "REJECTED",
};

/**
 * Get the appropriate color for a status value
 * @param {string} statusCode - The status code from the backend
 * @returns {string} CSS color value
 */
export const getStatusColor = (statusCode) => {
	switch (statusCode) {
		case LV_STATUS.DRAFT:
			return "#ffc107"; // Warning yellow
		case LV_STATUS.PENDING_INTERNAL:
			return "#17a2b8"; // Info blue
		case LV_STATUS.PENDING_CLIENT:
			return "#fd7e14"; // Orange
		case LV_STATUS.APPROVED:
			return "#28a745"; // Success green
		case LV_STATUS.REJECTED:
			return "#dc3545"; // Danger red
		default:
			return "#6c757d"; // Gray (default)
	}
};

/**
 * Map a backend status code to its corresponding translation key
 * The actual translation happens in the component using the t() function
 * @param {string} statusCode - The status code from the backend
 * @returns {string} Translation key for i18n
 */
export const getStatusTranslationKey = (statusCode) => {
	if (Object.values(LV_STATUS).includes(statusCode)) {
		// Return appropriate translation key
		return `lv.status.${statusCode.toLowerCase().replace("_", "-")}`;
	}

	return "lv.status.unknown";
};

export default LV_STATUS;
